export default "__VITE_ASSET__BsoO1tmi__"